import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { FreeBusyRules } from '../../components/free_busy_rules'


export const FreeBusyRulesPanel = (props) => (
  <AccordionPanel
    titleId="free-busy-rules-label"
    title={I18n.t('publisher.event_type_editor.sections.more_options.free_busy_rules.title')}
    subheader={<Summary />}
    {...props}
  >
    <FreeBusyRules />
  </AccordionPanel>
)
